<template>
    <div >
 
 
        <nav class="level is-mobile">
            <div class="level-left">
                <div class="level-item">
                    <p class="is-size-5"> Status  </p>
                </div>
                <div class="level-item">
                    <p v-if="dataNecropsySpecLN.status.id < 5 "  class="is-size-5 has-text-info"> &nbsp; {{ dataNecropsySpecLN.status.name }}  </p>
                    <p v-if="dataNecropsySpecLN.status.id >=5 && dataNecropsySpecLN.status.id <=6"  class="is-size-5 has-text-success"> &nbsp; {{ dataNecropsySpecLN.status.name }}  </p>
                    <p v-if="dataNecropsySpecLN.status.id === 7 "  class="is-size-5 has-text-danger"> &nbsp; {{ dataNecropsySpecLN.status.name }} </p>
                </div>
                <div class="level-item">
                    <b-icon icon="lock" type="is-danger"  v-if="dataNecropsySpecLN.status.id >=5 "  ></b-icon>
                    <b-icon icon="lock-open" type="is-success"  v-if="dataNecropsySpecLN.status.id < 5 "  ></b-icon>
                </div>
                <div class="level-item">
                    <p class="is-size-5"> Assigned for </p>
                </div>
                <div class="level-item">
                    <p class="is-size-5 has-text-grey"> &nbsp; {{ dataNecropsySpecLN.assigned_to_user.name }}</p>
                </div>
                <div class="level-item">
                    <b-button type="is-success"
                              id="button_edit"
                              icon-left="pencil"
                              @click="showEditDocLABTxtKind"
                              ref="btnEditLNNonautomate"
                              :disabled="!IDLABSelected.idlab "
                              v-if="
                                (
                                (  (dataNecropsySpecLN && (userRoleFind(3) || userRoleFind(4)  ))     )
                                || ( dataNecropsySpecLN && userIsAdmin )
                                ||  ( dataNecropsySpecLN && dataNecropsySpecLN.assigned_to_user.id === user_id )
                                )
                                && dataNecropsySpecLN.status.id <=5
                                        ">
                        Edit
                    </b-button>
                </div>
                <div class="level-item" v-if="dataNecropsySpecLN.status.id >=5 && userRoleFind(6)">
                    <b-dropdown aria-role="menu" position="is-bottom-left" :disabled="loadingReportFile || loadingImgReportFile || isSelectImgForMakePdf">
                        <template #trigger>
                            <b-button type="is-primary is-light" icon-left="file-pdf-box" icon-right="chevron-down"
                                      :loading="loadingReportFile" :disabled="loadingReportFile || loadingImgReportFile || isSelectImgForMakePdf" aria-haspopup="menu">
                                View as Pdf(Text)
                            </b-button>
                        </template>
                        <b-dropdown-item aria-role="menuitem" @click="selectReportMethod('legacy', false)">PDF แบบเดิม</b-dropdown-item>
                        <b-dropdown-item aria-role="menuitem" :disabled="dataNecropsySpecLN.status.id > 6"
                                         @click="selectReportMethod('reportlab', false)">PDF ReportLab</b-dropdown-item>
                    </b-dropdown>
                </div>
                <div class="level-item" v-if="dataNecropsySpecLN.status.id >=5 && userRoleFind(6)">
                    <b-dropdown aria-role="menu" position="is-bottom-left" :disabled="loadingReportFile || loadingImgReportFile || isSelectImgForMakePdf || !dataNecropsySpecLN.display_title_image_for_nonadmin">
                        <template #trigger>
                            <b-button type="is-primary is-light" icon-left="file-pdf-box" icon-right="chevron-down"
                                      :loading="loadingImgReportFile" :disabled="loadingReportFile || loadingImgReportFile || isSelectImgForMakePdf || !dataNecropsySpecLN.display_title_image_for_nonadmin" aria-haspopup="menu">
                                View as Pdf(Images)
                            </b-button>
                        </template>
                        <b-dropdown-item aria-role="menuitem" @click="selectReportMethod('legacy', true)">PDF แบบเดิม</b-dropdown-item>
                        <b-dropdown-item aria-role="menuitem" :disabled="dataNecropsySpecLN.status.id > 6"
                                         @click="selectReportMethod('reportlab', true)">PDF ReportLab</b-dropdown-item>
                    </b-dropdown>
                </div>
            </div>


            <div class="level-right" v-if="( (dataNecropsySpecLN.assigned_to_user.id === user_id )||(userIsAdmin) )&& (  dataNecropsySpecLN.status.id >= 5 &&  dataNecropsySpecLN.status.id <= 6)">
                <div class="level-item">
                    <b-button type="is-danger"
                              icon-left="plus"
                              class="btn_plus"
                              @click="plusSomething">Plus
                    </b-button>
                </div>
                <div class="level-item">
                    <b-field
                            :type="{ 'is-danger': hasErrorPlusSomethingSelected}"
                            :message="{ 'pls select  ': hasErrorPlusSomethingSelected}">
                        <b-select placeholder="Select Plus Type" v-model="plusSomethingSelected">
                            <option value = 0> {{headerInfoPrepare}} </option>
                            <option value = 1> {{findingAndContent}} </option>
                            <option value = 2> {{images_title}} </option>
                            <option value = 3> {{ClassificationOfDiseases}} </option>
                        </b-select>
                    </b-field>
                </div>
            </div>

        </nav>
        <hr>




        <div v-if="dataNecropsySpecLN !==null && dataNecropsySpecLN.status.id >= 5 && dataNecropsySpecLN.status.id <=6 " style="margin-left: 10px;">


            <!-- Display Title if normal or plus existing  -->
            <div class="container" v-if="  displayTitle(dataNecropsySpecLN.dat_prepare.dat_txt , dataNecropsySpecLN.data_plus.dat_prepare , dataNecropsySpecLN.display_title_prepare_for_nonadmin ) ">
                <TitlePlus :datUserWhoView="getNameAndSurname"
                           :titleDisplay="headerPrepareInfo"
                           :plus=false
                           :showIcon = true
                           :showDatUserWhoView = "false"
                           :showTitleDisplay = true
                           :iconToShow = "iconFileDocument"
                           :visible = "true"/>
            </div>


            <!----------------------  Prepared   disPlayOrNot   dataNecropsySpecLN && dataNecropsySpecLN.dat_prepare.dat_txt.length>0  ------>
            <div class="container"  v-if="disPlayOrNot(dataNecropsySpecLN ,dataNecropsySpecLN.dat_prepare.dat_txt.length ,dataNecropsySpecLN.dat_prepare.visible )" >
                <TitlePlus :datUserWhoView="getNameAndSurname"
                           :titleDisplay="headerPrepareInfo"
                           :plus=false
                           :showIcon = false
                           :showTitleDisplay = false
                           :visible = " dataNecropsySpecLN.dat_prepare.visible "/>
                <div class="box"  >
                    <div  v-html="getDecodeFromBase64ToHtml( dataNecropsySpecLN.dat_prepare.dat )"
                          :style= "getStyleVisibleFalseInContent(dataNecropsySpecLN.dat_prepare.visible)" >
                    </div>
                </div>
                <FooterPlus  :user_rec="dataNecropsySpecLN.dat_prepare.user_rec"
                             :date_rec="dataNecropsySpecLN.dat_prepare.date_rec"
                             :time_rec="dataNecropsySpecLN.dat_prepare.time_rec"
                             :user_delete="dataNecropsySpecLN.dat_prepare.user_edit"
                             :date_delete="dataNecropsySpecLN.dat_prepare.date_edit"
                             :time_delete="dataNecropsySpecLN.dat_prepare.time_edit"
                             :userIsAdmin="userIsAdmin"
                             :idToDelete = "dataNecropsySpecLN.dat_prepare.id.toString()"
                             :typeToDelete ="TYPE_TO_DELETE_NONAUTOMATE.prepare"
                             :labKind = "IDLABSelected.kind"
                             :canDelete ="dataNecropsySpecLN.dat_prepare.visible"
                             @footerPlusWithChangeDisable="footerPlusWithChangeDisable" />
            </div>
            <!----------------------- Prepare Plus  dataNecropsySpecLN && dataNecropsySpecLN.data_plus.dat_prepare.length>0 -->
            <div class="container" v-for="dat_prepare_plus in  dataNecropsySpecLN.data_plus.dat_prepare" :key="dat_prepare_plus.id">
                <div  class="container" v-if="disPlayOrNot(true,true,dat_prepare_plus.visible)">
                    <TitlePlus :datUserWhoView="getNameAndSurname"
                               :titleDisplay="headerPrepareInfoPlus"
                               :plus=true
                               :showIcon = false
                               :showTitleDisplay = false
                               :visible = " dat_prepare_plus.visible "
                    />
                    <div class="box"  >
                        <div v-html="getDecodeFromBase64ToHtml(dat_prepare_plus.dat)"  :style= "getStyleVisibleFalseInContent(dat_prepare_plus.visible)"
                        >
                        </div>
                    </div>
                    <FooterPlus  :user_rec="dat_prepare_plus.user_rec"
                                 :date_rec="dat_prepare_plus.date_rec"
                                 :time_rec="dat_prepare_plus.time_rec"
                                 :user_delete="dat_prepare_plus.user_edit"
                                 :date_delete="dat_prepare_plus.date_edit"
                                 :time_delete="dat_prepare_plus.time_edit"
                                 :canDelete ="dat_prepare_plus.visible"
                                 :userIsAdmin="userIsAdmin"
                                 :idToDelete = "dat_prepare_plus.id.toString()"
                                 :typeToDelete ="TYPE_TO_DELETE_NONAUTOMATE.prepare_plus"
                                 :labKind = "IDLABSelected.kind"
                                 @footerPlusWithChangeDisable="footerPlusWithChangeDisable"
                    />
                </div>
            </div>



            <!-- Display Title if normal or plus existing  -->
            <div class="container" v-if=" displayTitle(dataNecropsySpecLN.dat_ct.dat , dataNecropsySpecLN.data_plus.dat_ct ,dataNecropsySpecLN.display_title_ct_for_nonadmin ) ">
                <TitlePlus :datUserWhoView="getNameAndSurname"
                           :titleDisplay="findingAndContent"
                           :plus=false
                           :showIcon = true
                           :showDatUserWhoView = "false"
                           :showTitleDisplay = true
                           :iconToShow = "iconFileDocument"
                           :visible = "true"/>
            </div>



            <!----------------------  Content  ------>
            <div class="container"  v-if="disPlayOrNot(dataNecropsySpecLN ,dataNecropsySpecLN.dat_ct.dat_txt.length ,dataNecropsySpecLN.dat_ct.visible )" >

                <TitlePlus :datUserWhoView="getNameAndSurname"
                           :titleDisplay="findingAndContent"
                           :plus=false
                           :showIcon = false
                           :showTitleDisplay = false
                           :visible = " dataNecropsySpecLN.dat_ct.visible "/>
                <div class="box"  >
                    <div v-html="getDecodeFromBase64ToHtml( dataNecropsySpecLN.dat_ct.dat )"  :style= "getStyleVisibleFalseInContent(dataNecropsySpecLN.dat_ct.visible)"></div>
                </div>

                <FooterPlus  :user_rec="dataNecropsySpecLN.dat_ct.user_rec"
                             :date_rec="dataNecropsySpecLN.dat_ct.date_rec"
                             :time_rec="dataNecropsySpecLN.dat_ct.time_rec"
                             :user_delete="dataNecropsySpecLN.dat_ct.user_edit"
                             :date_delete="dataNecropsySpecLN.dat_ct.date_edit"
                             :time_delete="dataNecropsySpecLN.dat_ct.time_edit"
                             :canDelete ="dataNecropsySpecLN.dat_ct.visible"
                             :userIsAdmin="userIsAdmin"
                             :idToDelete = "dataNecropsySpecLN.dat_ct.id.toString()"
                             :typeToDelete ="TYPE_TO_DELETE_NONAUTOMATE.ct"
                             :labKind = "IDLABSelected.kind"
                             @footerPlusWithChangeDisable="footerPlusWithChangeDisable" />


            </div>

            <!--           Content Plus  -->
            <div  class="container"  v-for="dat_content_plus in  dataNecropsySpecLN.data_plus.dat_ct" :key="dat_content_plus.id">
                <template v-if="disPlayOrNot(true,true,dat_content_plus.visible)">
                    <TitlePlus :datUserWhoView="getNameAndSurname"
                               :titleDisplay="findingAndContentPlus"
                               :plus=true
                               :showIcon = false
                               :showTitleDisplay = false
                               :visible = " dat_content_plus.visible "/>
                    <div class="box"  >
                        <div v-html="getDecodeFromBase64ToHtml(dat_content_plus.dat)" :style= "getStyleVisibleFalseInContent(dat_content_plus.visible)"></div>
                    </div>
                    <FooterPlus  :user_rec="dat_content_plus.user_rec"
                                 :date_rec="dat_content_plus.date_rec"
                                 :time_rec="dat_content_plus.time_rec"
                                 :user_delete="dat_content_plus.user_edit"
                                 :date_delete="dat_content_plus.date_edit"
                                 :time_delete="dat_content_plus.time_edit"
                                 :canDelete ="dat_content_plus.visible"
                                 :userIsAdmin="userIsAdmin"
                                 :idToDelete = "dat_content_plus.id.toString()"
                                 :typeToDelete ="TYPE_TO_DELETE_NONAUTOMATE.ct_plus"
                                 :labKind = "IDLABSelected.kind"
                                 @footerPlusWithChangeDisable="footerPlusWithChangeDisable" />
                </template>
            </div>







            <!-- Display Title if normal or plus existing  -->
            <div class="container" v-if=" displayTitle(dataNecropsySpecLN.img.dat , dataNecropsySpecLN.data_plus.img , dataNecropsySpecLN.display_title_image_for_nonadmin )    ">
                <TitlePlus :datUserWhoView="getNameAndSurname"
                           :titleDisplay="images_title"
                           :plus=false
                           :showIcon = true
                           :showDatUserWhoView = "false"
                           :showTitleDisplay = true
                           :iconToShow = "iconImage"
                           :visible = "true"/>
            </div>

            <!----------------------  Images  ------>
            <template v-if="disPlayOrNot(dataNecropsySpecLN ,dataNecropsySpecLN.img.dat.length ,
                                         dataNecropsySpecLN.img.dat.length>0 ? dataNecropsySpecLN.img.dat[0].visible : false  )">
                <div class="container"  v-if="dataNecropsySpecLN && dataNecropsySpecLN.img.dat.length>0 " >
                    <TitlePlus :datUserWhoView="getNameAndSurname"
                               :titleDisplay="images_title"
                               :plus=false
                               :showDatUserWhoView = true
                               :showIcon = false
                               :showTitleDisplay = false
                    />



                    <ThumbnailImageList  v-if="dataPassThruImageList.length>0"
                                         :modeThumbnailImageList="modeThumbnailImageList"
                                         :dataPassThruImageList="dataPassThruImageList"
                                         :plus="false"/>


                    <FooterPlus  :user_rec="dataNecropsySpecLN.img.user_rec"
                                 :date_rec="dataNecropsySpecLN.img.date_rec"
                                 :time_rec="dataNecropsySpecLN.img.time_rec"
                                 :user_delete="dataNecropsySpecLN.img.user_edit"
                                 :date_delete="dataNecropsySpecLN.img.date_edit"
                                 :time_delete="dataNecropsySpecLN.img.time_edit"
                                 :canDelete ="dataNecropsySpecLN.img.user_edit.length>0 ? false : true"
                                 :userIsAdmin="userIsAdmin"
                                 :idToDelete = "IDLABSelected.idlab"
                                 :typeToDelete ="TYPE_TO_DELETE_NONAUTOMATE.images"
                                 :labKind = "IDLABSelected.kind"
                                 @footerPlusWithChangeDisable="footerPlusWithChangeDisable" />
                </div>

            </template>
            <!----------------------   Image Plus  ------>
            <div  class="container"  v-for=" img in dataNecropsySpecLN.data_plus.img" :key="img.idtime">
                <template v-if="disPlayOrNot(true,true,img.visible[0])">
                    <TitlePlus :datUserWhoView="getNameAndSurname"
                               :titleDisplay="ImagePlus"
                               :plus=true
                               :showIcon = false
                               :showTitleDisplay = false
                               :showDatUserWhoView = true
                    />
                    <br>
                    <ThumbnailImageList    :modeThumbnailImageList="modeThumbnailImageList" :dataPassThruImageList="dataPassThruImageListPlus(img.idtime)"  :plus="true"  />
                    <FooterPlus  :user_rec="getUserRecImgPlusByIdTime(img.idtime)"
                                 :date_rec="getDateRecImgPlusByIdTime(img.idtime)"
                                 :time_rec="getTimeRecImgPlusByIdTime(img.idtime)"
                                 :user_delete="img.user_edit.length>0 ? img.user_edit[0] : '' "
                                 :date_delete="img.date_edit.length>0 ? img.date_edit[0] : '' "
                                 :time_delete="img.time_edit.length>0 ? img.time_edit[0] : ''"
                                 :canDelete ="img.visible.length>0 ? img.visible[0] : false"
                                 :userIsAdmin="userIsAdmin"
                                 :idToDelete = "img.idtime.toString()"
                                 :typeToDelete ="TYPE_TO_DELETE_NONAUTOMATE.images_plus"
                                 :labKind = "IDLABSelected.kind"
                                 @footerPlusWithChangeDisable="footerPlusWithChangeDisable" />
                    <br>
                </template>
            </div>



            <!---------------- Display Title if normal or plus existing  -->
            <div class="container" v-if="  displayTitle(dataNecropsySpecLN.diag_code.dat , dataNecropsySpecLN.data_plus.diag_code , dataNecropsySpecLN.display_title_diag_for_nonadmin)   ">
                <TitlePlus :datUserWhoView="getNameAndSurname"
                           :titleDisplay="ClassificationOfDiseases"
                           :plus=false
                           :showIcon = true
                           :showDatUserWhoView = "false"
                           :showTitleDisplay = true
                           :iconToShow = "iconDx"
                           :visible = "true"/>
            </div>



            <!----------------------  Diagosis  ------>
            <template v-if="disPlayOrNot(dataNecropsySpecLN ,dataNecropsySpecLN.diag_code.dat.length ,
                                         dataNecropsySpecLN.diag_code.dat.length>0 ? dataNecropsySpecLN.diag_code.dat[0].visible : false  )">
                <div class="container"  v-if="dataNecropsySpecLN && dataNecropsySpecLN.diag_code.dat.length>0" >
                    <TitlePlus :datUserWhoView="getNameAndSurname"
                               :titleDisplay="ClassificationOfDiseases"
                               :plus=false
                               :showIcon = false
                               :showDatUserWhoView = "true"
                               :showTitleDisplay = false
                    />
                    <b-table             :data="isEmpty ? [] : dataNecropsySpecLN.diag_code.dat "
                                         bordered
                                         striped
                                         narrowed
                                         hoverable
                                         focusable
                                         mobile-cards
                    >


                        <b-table-column field="level1Name" label="Chapter" v-slot="props">
                            {{ props.row.level1Name }}
                        </b-table-column>

                        <b-table-column field="level2Name" label="Body System" v-slot="props">
                            {{ props.row.level2Name }}
                        </b-table-column>

                        <b-table-column field="level3Name" label="Organ/Tissue" v-slot="props">
                            {{ props.row.level3Name }}
                        </b-table-column>

                        <b-table-column field="level4Name" label="Character/Subcategories" v-slot="props">
                            {{ props.row.level4Name }}
                        </b-table-column>

                        <b-table-column field="level5Name" label="Extensions" v-slot="props">
                            {{ props.row.level5Name }}
                        </b-table-column>


                        <b-table-column field="level5Name" label="Unclassified Descriptions" v-slot="props">
                            {{ props.row.unClassifiedCodes }}
                        </b-table-column>


                        <b-table-column field="level5Name" label="%" v-slot="props">
                            {{ props.row.labDiseasecodeAccurateName }}
                        </b-table-column>


                        <b-table-column field="level5Name" label="Comment"  v-slot="props">
                            {{ props.row.comment }}
                        </b-table-column>

                    </b-table>
                    <FooterPlus  :user_rec="dataNecropsySpecLN.diag_code.user_rec"
                                 :date_rec="dataNecropsySpecLN.diag_code.date_rec"
                                 :time_rec="dataNecropsySpecLN.diag_code.time_rec"

                                 :user_delete="dataNecropsySpecLN.diag_code.user_edit"
                                 :date_delete="dataNecropsySpecLN.diag_code.date_edit"
                                 :time_delete="dataNecropsySpecLN.diag_code.time_edit"
                                 :canDelete ="dataNecropsySpecLN.diag_code.user_edit.length>0 ? false : true"

                                 :userIsAdmin="userIsAdmin"
                                 :idToDelete = "IDLABSelected.idlab"
                                 :typeToDelete ="TYPE_TO_DELETE_NONAUTOMATE.diag_code"
                                 :labKind = "IDLABSelected.kind"
                                 @footerPlusWithChangeDisable="footerPlusWithChangeDisable"/>
                    <br>
                </div>

            </template>

            <!----------------------         Diagnosis Plus   dataNecropsySpecLN.data_plus.diag_code  v-if="dataNecropsySpecLN.data_plus.diag_code.length>0"-->

            <div  class="container"  v-for=" diag_code_plus in dataNecropsySpecLN.data_plus.diag_code" :key="diag_code_plus.idtime">
                <template v-if="disPlayOrNot(true,true,diag_code_plus.visible)">



                    <TitlePlus
                            :datUserWhoView="getNameAndSurname"
                            :titleDisplay="ClassificationOfDiseases"
                            :plus=true
                            :showIcon = false
                            :showTitleDisplay = false
                            :showDatUserWhoView = true
                    />
                    <b-table         :data="diag_code_plus.dat"
                                     bordered
                                     striped
                                     narrowed
                                     hoverable
                                     focusable
                                     mobile-cards
                    >
                        <b-table-column   label="Chapter" v-slot="props">
                            {{ props.row.level1Name }}
                        </b-table-column>
                        <b-table-column   label="Body System" v-slot="props">
                            {{ props.row.level2Name }}
                        </b-table-column>
                        <b-table-column   label="Organ/Tissue" v-slot="props">
                            {{ props.row.level3Name }}
                        </b-table-column>
                        <b-table-column   label="Character/Subcategories" v-slot="props">
                            {{ props.row.level4Name }}
                        </b-table-column>
                        <b-table-column   label="Extensions" v-slot="props">
                            {{ props.row.level5Name }}
                        </b-table-column>
                        <b-table-column  label="Unclassified Descriptions" v-slot="props">
                            {{ props.row.unClassifiedCodes }}
                        </b-table-column>
                        <b-table-column  label="%" v-slot="props">
                            {{ props.row.labDiseasecodeAccurateName }}
                        </b-table-column>
                        <b-table-column  label="Remark" v-slot="props">
                            {{ props.row.comment }}
                        </b-table-column>

                    </b-table>
                    <FooterPlus  :user_rec="diag_code_plus.dat[0].user_rec"
                                 :date_rec="diag_code_plus.dat[0].date_rec"
                                 :time_rec="diag_code_plus.dat[0].time_rec"
                                 :user_delete="diag_code_plus.dat[0].user_edit.length>0 ? diag_code_plus.dat[0].user_edit : '' "
                                 :date_delete="diag_code_plus.dat[0].date_edit.length>0 ? diag_code_plus.dat[0].date_edit : '' "
                                 :time_delete="diag_code_plus.dat[0].time_edit.length>0 ? diag_code_plus.dat[0].time_edit : '' "
                                 :canDelete ="diag_code_plus.visible"
                                 :userIsAdmin="userIsAdmin"
                                 :idToDelete = "diag_code_plus.idtime.toString()"
                                 :typeToDelete ="TYPE_TO_DELETE_NONAUTOMATE.diag_code_plus"
                                 :labKind = "IDLABSelected.kind"
                                 @footerPlusWithChangeDisable="footerPlusWithChangeDisable" />

                </template>
            </div>


            <!---------------- Display Title if normal or plus existing  -->
            <div   class="container"   v-if="  dataNecropsySpecLN ">
                <TitlePlus :datUserWhoView="getNameAndSurname"
                           :titleDisplay="RequestedInfo"
                           :plus=false
                           :showIcon = true
                           :showDatUserWhoView = "false"
                           :showTitleDisplay = true
                           :iconToShow = "iconInfoRequest"
                           :visible = "true"/>
            </div>
            <!-----------------     Request Info.  ----------------->
            <div class="container"  v-if="dataNecropsySpecLN" >
                <TitlePlus
                        :datUserWhoView="getNameAndSurname"
                        :titleDisplay="RequestedInfo"
                        :plus=false
                        :showIcon = false
                        :showTitleDisplay = false
                        :showDatUserWhoView = true
                />
                <FooterRequest :dataReqToFooter="dataNecropsySpecLN.data_req"/>
            </div>















 
        </div>


        <EditDocLabNecrop ref="EditDocLabNecrop"
                          :IDLABSelected="IDLABSelected"
                          @close="closeEditDocLAB"
        />


        <PlusEditor   v-if="isPlusEditor"
                      :isShowing="isPlusEditor"
                      :idlab="IDLABSelected.idlab"
                      :labKind="IDLABSelected.kind"
                      :submitTypePlusEdit="submitTypePlusEditTmp"
                      @close="closePlusEditor"
                      @closeWithChange="closePlusEditorWithChange" />
        <PlusImages  v-if="isPlusImages"
                     :isShowing="isPlusImages"
                     :idlab="IDLABSelected.idlab"
                     @closePlusImagesWithData="closePlusImagesWithData"
                     @closePlusImages="closePlusImages"/>

        <PlusSelectDiseaseCode v-if="isPlusSelectDiseaseCode"
                               :idlab="IDLABSelected.idlab"
                               :isShowing="isPlusSelectDiseaseCode"
                               @closePlusSelectDiseaseCode_WithChange = "closePlusSelectDiseaseCode_WithChange"
                               @closePlusSelectDiseaseCode="closePlusSelectDiseaseCode"/>



 

        <b-modal
                v-model="isSelectImgForMakePdf"
                has-modal-card
                full-screen
                :can-cancel="true">
            <SelectImgForMakePdf
                    :arrImg = "arrPropsToImgReport"
                    @closeSelectImgForMakePdfWithDataWantTo="doReqImageReportFile"
                    @closeSelectImgForMakePdf="closeSelectImgForMakePdf"/>
        </b-modal>

 
    </div>
</template>

<script>
    import userRoleFind from "../../mixins/methods/userRoleFind";
    import globalconst from "../../mixins/globalconst";
    import { genUUID, getBaseURLAvartar , DATANECROPSPECLN_MODEL } from '@/utils.js'
    import {mapActions, mapState} from "vuex";
    import EditDocLabNecrop from "./EditDocLabNecrop.vue";
    import ThumbnailImageList from "../UtilsComponents/ThumbnailImageList";
    import FooterRequest from "./FooterRequest";

    import TitlePlus from "./Plus/TitlePlus";
    import FooterPlus from "./Plus/FooterPlus";

    import PlusImages from "./Plus/PlusImages";
    import PlusEditor from "./Plus/PlusEditor";
    import PlusSelectDiseaseCode from "./Plus/PlusSelectDiseaseCode";
    import changeStatusFromIncompleteToComplete from "../../mixins/methods/changeStatusFromIncompleteToComplete";

    import disPlayOrNot from "../../mixins/methods/disPlayOrNot";
    import iconTitle from "../../mixins/data/iconTitle";
    import getStyleVisibleFalseInContent from "../../mixins/methods/getStyleVisibleFalseInContent";
    import getDecodeFromBase64ToHtml from "../../mixins/methods/getDecodeFromBase64ToHtml";
    import doNecropsyReportLab from "../../mixins/methods/doNecropsyReportLab";
    import doReportFile from "../../mixins/methods/doReportFile";
    import selectURL_NextFrom_DoReportFile_ByCallFrmVar from "../../mixins/methods/selectURL_NextFrom_DoReportFile_ByCallFrmVar";
     
    import displayTitle from "../../mixins/methods/displayTitle";
    import FileSaver from 'file-saver'



    import SelectImgForMakePdf from "./SelectImgForMakePdf/SelectImgForMakePdf";

    export default {
        name: "Necropsy_EachID",
        components:{
            EditDocLabNecrop,
            ThumbnailImageList,
            FooterRequest,

            TitlePlus,
            FooterPlus,

            PlusImages,
            PlusEditor ,
            PlusSelectDiseaseCode,

            SelectImgForMakePdf

        },
        props:{
            dataNecropsySpecLN : DATANECROPSPECLN_MODEL,
            IDLABSelected: null ,
        },
        mounted() {
         
        },
        computed:{
            ...mapState({
                user_id: state => state.master_data.user_id,
                user_role :  state => state.master_data.user_role,
                userIsAdmin:  state => state.master_data.userIsAdmin,
                OPDSelected : state => state.opd_target.opd_selected,
                clientIP: state => state.master_data.clientIP,
                access_token: state => state.master_data.access_token,
            }),
            getNameAndSurname: function(){
                // return 'test'
                const userFullName = localStorage.getItem('user_name_surname')
                return  `<p class="has-text-weight-light has-text-grey-lighter" style="color: #00b89c; padding-top: 15px"> View by ${userFullName}
                          ${this.dataNecropsySpecLN.current_date}
                          ${this.dataNecropsySpecLN.current_time} </p>`
                // return localStorage.getItem('user_name_surname')
            },
            dataPassThruImageList: function () {
                // [ { id: tmpID ,
                //     file : null,
                //     urlTempUploaded: tmpUrl,
                //     title : vm.dataAllContent.img.dat[i].title,
                //     fileNameUploaded:  vm.dataAllContent.img.dat[i].file ,
                //     fresh : false  } ]

                return this.dataNecropsySpecLN.img.dat.map(dat => {
                    return   { id: genUUID(5) ,
                        file : null,
                        urlTempUploaded: `${getBaseURLAvartar()}/${this.IDLABSelected.idlab}/${dat.file}`,
                        title : dat.title,
                        fileNameUploaded: dat.file,
                        fresh : false  }

                })
            }
        },
        mixins:[globalconst, userRoleFind, changeStatusFromIncompleteToComplete, disPlayOrNot, iconTitle, getStyleVisibleFalseInContent,
                getDecodeFromBase64ToHtml, doReportFile, doNecropsyReportLab , selectURL_NextFrom_DoReportFile_ByCallFrmVar , displayTitle],
        methods:{
            ...mapActions({
                fetchMyJobsTray: 'myjobstray/fetchMyJobsTray',
            }),


            closeSelectImgForMakePdf(){
                this.isSelectImgForMakePdf = false
            },

            selectReportMethod(engine, images) {
                if (this.loadingReportFile || this.loadingImgReportFile || this.isSelectImgForMakePdf) return
                if (engine === 'reportlab' && this.dataNecropsySpecLN.status.id > 6) return
                this.reportEngine = engine
                if (images) this.reqImageReportFile()
                else this.reqReportFile(false, -1, [])
            },

            reqImageReportFile(){
                if  (this.dataNecropsySpecLN.display_title_image_for_nonadmin){
                    // build arr
                    // {"id":1  , "descp": "lorem","select": true,"url": "http://127.0.0.1:5000/static/uploads/64BIOP0000000155/179452040286.jpg"}
                    // `${getBaseURLAvartar()}/${this.IDLABSelected.idlab}/${dat.file}`,
                    this.arrPropsToImgReport = []
                    //genUUID
                    this.dataNecropsySpecLN.img.dat.forEach(dat=>{
                        if (dat.visible){
                            this.arrPropsToImgReport.push(   {"id":genUUID(5)  , "descp": "", "select": false,"url": `${getBaseURLAvartar()}/${this.IDLABSelected.idlab}/${dat.file}` , "file": dat.file }  )
                        }
                    })
                    //
                    for(var i =0 ; i<this.dataNecropsySpecLN.data_plus.img.length;i++){
                        for(var j =0; j < this.dataNecropsySpecLN.data_plus.img[i].visible.length ; j++){
                            if (this.dataNecropsySpecLN.data_plus.img[i].visible[j]){
                                this.arrPropsToImgReport.push(
                                                              {"id":genUUID(5)  , "descp": "", "select": false,
                                                               "url": `${getBaseURLAvartar()}/${this.IDLABSelected.idlab}/${this.dataNecropsySpecLN.data_plus.img[i].file[j]}` ,
                                                               "file": this.dataNecropsySpecLN.data_plus.img[i].file[j]
                                                              }
                                                             )
                            }
                        }

                    }


                   if ( this.arrPropsToImgReport.length >0 ){
                       this.isSelectImgForMakePdf = true
                   }else{
                       this.$buefy.dialog.alert({
                           title: 'Error',
                           message: `Nothing Images`,
                           type: 'is-danger',
                           hasIcon: true,
                           icon: 'times-circle',
                           iconPack: 'fa',
                           ariaRole: 'alertdialog',
                           ariaModal: true
                       })
                   }



                }

            },


            doReqImageReportFile(payload){
                this.isSelectImgForMakePdf = false
                var arr_img_data_want = []
                for(var i=0;i<payload.arrImg.length;i++){
                    if (payload.arrImg[i].select){
                        arr_img_data_want.push(payload.arrImg[i].file)
                    }
                }

                this.reqReportFile(true,parseInt( payload.num_of_col ) ,arr_img_data_want)


            },

            reqReportFile(pure_Img,col_if_pure_img,arr_img_data_want){
                let previewWindow = null
                if (this.reportEngine === 'reportlab') {
                    previewWindow = window.open('', '_blank')
                    if (!previewWindow) {
                        this.$buefy.dialog.alert({title: 'PDF Preview', message: 'กรุณาอนุญาต popup สำหรับเว็บไซต์นี้ แล้วลองอีกครั้ง', type: 'is-warning'})
                        return
                    }
                    previewWindow.opener = null
                    previewWindow.document.title = 'PDF Preview'
                    previewWindow.document.body.textContent = 'กำลังสร้าง PDF…'
                }
                if(pure_Img){
                    this.loadingImgReportFile = true
                    }else{
                    this.loadingReportFile = true
                }

                const useReportLab = this.reportEngine === 'reportlab'
                const report = useReportLab
                    ? this.doNecropsyReportLab(pure_Img,col_if_pure_img,arr_img_data_want)
                    : this.doReportFile(this.IDLABSelected,this.clientIP,pure_Img,col_if_pure_img,arr_img_data_want)
                report.then(res=>{
                         if (useReportLab) {
                             if (previewWindow.closed) return
                             const blobUrl = URL.createObjectURL(res)
                             try {
                                 previewWindow.location.replace(blobUrl)
                             } catch (error) {
                                 URL.revokeObjectURL(blobUrl)
                                 throw error
                             }
                             // Keep the URL valid for the viewer's print/download actions.
                             const cleanup = window.setInterval(() => {
                                 if (previewWindow.closed) {
                                     URL.revokeObjectURL(blobUrl)
                                     window.clearInterval(cleanup)
                                 }
                             }, 1000)
                         }
                         else FileSaver.saveAs(this.selectURL_NextFrom_DoReportFile_ByCallFrmVar(res), `${res.file_name}.pdf`);
                         if(pure_Img){
                             this.loadingImgReportFile = false
                         }else{
                             this.loadingReportFile = false
                         }
                     })
                    .catch(err=>{
                        if (previewWindow && !previewWindow.closed) previewWindow.close()
                        this.$buefy.dialog.alert({
                            title: 'Error',
                            message: String((err.response && err.response.data && err.response.data.msg) || err.message || 'ไม่สามารถสร้าง PDF ได้').replace(/[&<>"']/g, ch => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[ch])),
                            type: 'is-danger',
                            hasIcon: true,
                            icon: 'times-circle',
                            iconPack: 'fa',
                            ariaRole: 'alertdialog',
                            ariaModal: true
                        })
                        if(pure_Img){
                            this.loadingImgReportFile = false
                        }else{
                            this.loadingReportFile = false
                        }
                    })
                    .finally(()=>{
                        if(pure_Img){
                            this.loadingImgReportFile = false
                        }else{
                            this.loadingReportFile = false
                        }
                    })
            },








            dataAvartar(iduser,avatar){
                return  `${getBaseURLAvartar()}/user_${iduser}/${avatar}`
            },
            closeEditDocLAB(){
                this.$emit('close')
            },
            showEditDocLABTxtKind(){
                this.$refs.EditDocLabNecrop.loadData()
                this.$refs.EditDocLabNecrop.getMyTemplateLocal()
                this.$refs.EditDocLabNecrop.isComponentModalActive = true
            },

            // Plus
            plusSomething(){
                if(this.plusSomethingSelected === null){
                    this.hasErrorPlusSomethingSelected = true
                    return
                }


                if(this.plusSomethingSelected  == 0){
                    this.showPlusEditor(this.SUBMIT_TYPE_PLUS_EDIT.prepare)
                }else if (this.plusSomethingSelected  == 1){
                    this.showPlusEditor(this.SUBMIT_TYPE_PLUS_EDIT.ct)
                }else if (this.plusSomethingSelected  == 2){
                    this.showPlusImages()
                }else if (this.plusSomethingSelected  == 3){
                    this.addPlusSelectDiseaseCode()
                }else {
                    return
                }
            },
            closePlusEditor(){
                this.isPlusEditor = false
            },
            closePlusEditorWithChange(){
                this.$emit('trigForPlusUpdate')
                this.isPlusEditor = false
            },
            closePlusImagesWithData(){
                this.isPlusImages = false
                this.$emit('trigForPlusUpdate')
            },
            closePlusImages(){
                this.isPlusImages = false
            },
            closePlusSelectDiseaseCode_WithChange(){
                this.$emit('trigForPlusUpdate')
                this.isPlusSelectDiseaseCode = false
            },
            closePlusSelectDiseaseCode(){
                this.isPlusSelectDiseaseCode = false
            },
            showPlusEditor(_type){
                this.submitTypePlusEditTmp = _type
                this.isPlusEditor = true
            },
            showPlusImages(){
                this.isPlusImages = true
            },
            addPlusSelectDiseaseCode(){
                this.isPlusSelectDiseaseCode = true
            },
            footerPlusWithChangeDisable(){
                this.$emit('trigForPlusUpdate')
            },



            //
            getTimeRecImgPlusByIdTime(_idtime){
                const member  = this.dataNecropsySpecLN.data_plus.img.find(data=> data.idtime === _idtime )
                return member.time_rec[0]
            },
            getDateRecImgPlusByIdTime(_idtime){
                const member  = this.dataNecropsySpecLN.data_plus.img.find(data=> data.idtime === _idtime )
                return member.date_rec[0]
            },
            getUserRecImgPlusByIdTime(_idtime){
                const member  = this.dataNecropsySpecLN.data_plus.img.find(data=> data.idtime === _idtime )
                return member.user_rec[0]
            },
            dataPassThruImageListPlus(_idtime) {
                if(this.dataNecropsySpecLN.data_plus.img.length>0) {
                    const member = this.dataNecropsySpecLN.data_plus.img.find(data => data.idtime === _idtime)
                    var tmpArr = []
                    for (var i = 0; i <= member.id.length - 1; i++) {
                        const tmp = {
                            id: member.id[i],
                            file: null,
                            urlTempUploaded: `${getBaseURLAvartar()}/${this.IDLABSelected.idlab}/${member.file[i]}`,
                            title: member.title[i],
                            fileNameUploaded: member.file[i],
                            fresh: false
                        }
                        tmpArr.push(tmp)
                    }
                    return tmpArr
                }else{
                    return []
                }
            }

        },
        data(){
            return {
                modeThumbnailImageList : "view",
                dataReqToFooter : [],
                isEmpty : false,
                // Plus
                submitTypePlusEditTmp : "",
                isPlusEditor : false,
                isModalUploadFiles : false,
                isPlusSelectDiseaseCode : false,
                isPlusImages : false,
                plusSomethingSelected : null,
                hasErrorPlusSomethingSelected : false,




                reportEngine: 'legacy',
                isSelectImgForMakePdf : false,
                arrPropsToImgReport : []


            }
        }
    }
</script>

<style scoped>

</style>